<template>
	<nav class="navbar fixed-top navbar-expand-lg"
		 v-bind:style="{
			background: siteSetting ? siteSetting.menuBackColor : ''
		}"
		 v-bind:class="{ scroll: scrollPosition > 80 }">
		<div class="container">
			<div class="row d-block w-100">
				<div class="navbar-brand float-left">
					<router-link :to="{ name: 'cart' }"
								 class="mr-2 ml-2 mr-md-2 ml-md-5"
								 style="position:relative;top:4px;">
						<font-awesome-icon v-bind:style="{
								'font-size': '22px',
								color: siteSetting
									? siteSetting.menuTextColor
									: ''
							}"
										   icon="shopping-cart" />

						<b-badge variant="light"
								 style="position:relative;top:-15px; left:30px;">{{ cart.items.length }}</b-badge>
					</router-link>
					<a class="ml-5" @mouseover="onOver" @mouseleave="onLeave">
						<b-dropdown variant="link"
									ref="dropdown"
									class="fade-in"
									toggle-class="p-0 mt-1"
									no-caret>
							<template v-slot:button-content>
								<svg aria-hidden="true"
									 focusable="false"
									 data-prefix="fas"
									 data-icon="th"
									 role="img"
									 xmlns="http://www.w3.org/2000/svg"
									 viewBox="0 0 512 512"
									 class="mr-2 ml-0 mr-md-2 ml-md-5 svg-inline--fa fa-th fa-w-16"
									 style="font-size: 22px;">
									<path data-v-0fe699b4=""
										  fill="currentColor"
										  d="M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
										  class=""></path>
								</svg>
							</template>
							<b-dropdown-item-button>
								<router-link class="text-dark float-right d-block"
											 :to="{ name: 'shops' }">
									<div class="col-2 float-right">
										<font-awesome-icon class="mr-2 ml-2 mr-md-2 ml-md-5"
														   icon="shopping-cart" />
									</div>
									<div class="col-2 float-right">
										<span>فروشگاه ها</span>
									</div>
									<div class="col-12 text-right float-right">
										<small>
											لیست فروشگاه های طرف قرارداد
											رامنیک
										</small>
									</div>
								</router-link>
							</b-dropdown-item-button>
							<b-dropdown-divider></b-dropdown-divider>
							<b-dropdown-item-button>
								<router-link class="text-dark float-right d-block"
											 :to="{ name: 'products' }">
									<div class="col-2 float-right">
										<font-awesome-icon class="mr-2 ml-2"
														   icon="shopping-bag" />
									</div>
									<div class="col-2 float-right">
										<span>نی مارکت</span>
									</div>
									<div class="col-12 text-right float-right">
										<small>
											مشاهده و خرید محصولات نی
											مارکت
										</small>
									</div>
								</router-link>
							</b-dropdown-item-button>
							<b-dropdown-divider></b-dropdown-divider>
							<b-dropdown-item-button>
								<router-link class="text-dark float-right d-block"
											 :to="{
										name: 'club',
										params: { action: 'requests' }
									}">
									<div class="col-2 float-right">
										<font-awesome-icon class="mr-2 ml-2"
														   icon="credit-card" />
									</div>
									<div class="col-2 float-right">
										<span>درخواست صدور نیکارت</span>
									</div>
									<div class="col-12 text-right float-right">
										<small>
											ارسال درخواست صدور اولیه
											نیکارت
										</small>
									</div>
								</router-link>
							</b-dropdown-item-button>
							<b-dropdown-divider></b-dropdown-divider>
							<b-dropdown-item-button>
								<router-link class="text-dark float-right d-block"
											 :to="{
										name: 'club',
										params: { action: 'requests' }
									}">
									<div class="col-2 float-right">
										<font-awesome-icon class="mr-2 ml-2"
														   icon="battery-full" />
									</div>
									<div class="col-2 float-right">
										<span>درخواست شارژ نیکارت</span>
									</div>
									<div class="col-12 text-right float-right">
										<small>
											ارسال درخواست شارژ نیکارت
										</small>
									</div>
								</router-link>
							</b-dropdown-item-button>
							<b-dropdown-divider></b-dropdown-divider>
							<b-dropdown-item-button>
								<router-link class="text-dark float-right d-block"
											 :to="{
										name: 'club',
										params: { action: 'requests' }
									}">
									<div class="col-2 float-right">
										<font-awesome-icon class="mr-2 ml-2"
														   icon="credit-card" />
									</div>
									<div class="col-2 float-right">
										<span>اعلام مفقودی نیکارت</span>
									</div>
									<div class="col-12 text-right float-right">
										<small>
											ارسال درخواست اعلام مفقودی نیکارت
										</small>
									</div>
								</router-link>
							</b-dropdown-item-button>
							<b-dropdown-divider></b-dropdown-divider>
							<b-dropdown-item-button>
								<router-link class="text-dark float-right d-block"
											 :to="{ name: 'blog' }">
									<div class="col-2 float-right">
										<font-awesome-icon class="mr-2 ml-2"
														   icon="rss" />
									</div>
									<div class="col-2 float-right">
										<span>اخبار</span>
									</div>
									<div class="col-12 text-right float-right">
										<small>
											از جدیدترین اخبار مربوط به رامنیک
											مطلع شوید
										</small>
									</div>
								</router-link>
							</b-dropdown-item-button>
							<b-dropdown-divider></b-dropdown-divider>
							<b-dropdown-item-button>
								<router-link class="text-dark float-right d-block"
											 :to="{
										name: 'content',
										params: { slug: 'about-us' }
									}">
									<div class="col-2 float-right">
										<font-awesome-icon class="mr-2 ml-2"
														   icon="info-circle" />
									</div>
									<div class="col-2 float-right">
										<span>درباره ما</span>
									</div>
									<div class="col-12 text-right float-right">
										<small>
											در رابطه با شرکت راه آرمان مهر
											نیکان (رامنیک)
										</small>
									</div>
								</router-link>
							</b-dropdown-item-button>
							<b-dropdown-divider></b-dropdown-divider>
							<b-dropdown-item-button>
								<router-link class="text-dark float-right d-block"
											 :to="{
										name: 'content',
										params: { slug: 'contact-us' }
									}">
									<div class="col-2 float-right">
										<font-awesome-icon class="mr-2 ml-2"
														   icon="phone" />
									</div>
									<div class="col-2 float-right">
										<span>ارتباط با ما</span>
									</div>
									<div class="col-12 text-right float-right">
										<small>راه های ارتباطی با ما</small>
									</div>
								</router-link>
							</b-dropdown-item-button>
							<b-dropdown-divider></b-dropdown-divider>
							<b-dropdown-item-button>
								<router-link class="text-dark float-right d-block"
											 :to="{ name: 'faq' }">
									<div class="col-2 float-right">
										<font-awesome-icon class="mr-2 ml-2"
														   icon="question" />
									</div>
									<div class="col-2 float-right">
										<span>سوالات متداول</span>
									</div>
									<div class="col-12 text-right float-right">
										<small>
											پاسخ سوالات خود را در این بخش
											بیابید
										</small>
									</div>
								</router-link>
							</b-dropdown-item-button>
						</b-dropdown>
					</a>
					<a href="/" class="logo">
						<span class="d-none"
							  v-bind:style="{
								color: siteSetting
									? siteSetting.menuTextColor
									: ''
							}">Ramnic E-commerce</span>
						<strong class="r">
							<img src="../../assets/image/LogoR.png" />
						</strong>
					</a>
				</div>
				<div class="navbar-toggler">
					<font-awesome-icon v-b-toggle.sidebar-menus
									   class="mr-4 mt-1 pink"
									   v-bind:style="{
							'font-size': '24px',
							color: siteSetting ? siteSetting.menuTextColor : ''
						}"
									   icon="bars" />
				</div>
				<div class="collapse navbar-collapse" id="navbarNav">
					<ul class="navbar-nav pt-1">
						<li class="nav-item active">
							<router-link class="nav-link"
										 v-bind:style="{
									color: siteSetting
										? siteSetting.menuTextColor
										: ''
								}"
										 :to="{ name: 'home' }">
								<font-awesome-icon class="mr-2 ml-2"
												   icon="home" />{{ $t("view.home.menu.home") }}
							</router-link>
						</li>
						<li class="nav-item active" v-if="customer">
							<router-link class="nav-link"
										 v-bind:style="{
									color: siteSetting
										? siteSetting.menuTextColor
										: ''
								}"
										 to="/club/dashboard">
								{{ customer.fullName }} عزیز خوش آمدید
							</router-link>
						</li>
						<li class="nav-item active" v-else>
							<router-link class="nav-link"
										 v-bind:style="{
									color: siteSetting
										? siteSetting.menuTextColor
										: ''
								}"
										 :to="{ name: 'auth' }">
								<font-awesome-icon class="mr-2 ml-2"
												   icon="sign-in-alt" />ورود اعضا / ثبت نام
							</router-link>
						</li>
						<li class="nav-item active"
							@click="$bvModal.show('OrderingModal')">
							<a class="nav-link"
							   v-bind:style="{
									cursor: 'pointer',
									color: siteSetting
										? siteSetting.menuTextColor
										: ''
								}">
								<font-awesome-icon class="mr-2 ml-2"
												   icon="angle-left" />سفارش کالا
							</a>
						</li>
						<li class="nav-item active"
							@click="$bvModal.show('ShopRequestModal')">
							<a class="nav-link"
							   v-bind:style="{
									cursor: 'pointer',
									color: siteSetting
										? siteSetting.menuTextColor
										: ''
								}">
								<font-awesome-icon class="mr-2 ml-2"
												   icon="angle-left" />درخواست همکاری فروشگاه
							</a>
						</li>
					</ul>
				</div>
				<b-sidebar id="sidebar-menus" right no-header backdrop shadow>
					<ul class="list-group p-0 list-group-flush">
						<li class="list-group-item  bg-light">
							<router-link class="text-dark"
										 :to="{ name: 'home' }">
								<font-awesome-icon class="mr-2 ml-2"
												   icon="home" />{{ $t("view.home.menu.home") }}
							</router-link>
						</li>
						<li v-b-toggle.sidebar-menus
							class="list-group-item  bg-light"
							@click="$bvModal.show('OrderingModal')">
							<a class="text-dark"
							   v-bind:style="{
									cursor: 'pointer',
									color: siteSetting
										? siteSetting.menuTextColor
										: ''
								}">
								<font-awesome-icon class="mr-2 ml-2 text-dark"
												   icon="angle-left" />سفارش کالا
							</a>
						</li>
						<li v-b-toggle.sidebar-menus
							class="list-group-item  bg-light"
							@click="$bvModal.show('ShopRequestModal')">
							<a class="text-dark"
							   v-bind:style="{
									cursor: 'pointer',
									color: siteSetting
										? siteSetting.menuTextColor
										: ''
								}">
								<font-awesome-icon class="mr-2 ml-2 text-dark"
												   icon="angle-left" />درخواست همکاری فروشگاه
							</a>
						</li>

						<li class="list-group-item  bg-light">
							<router-link class="text-dark"
										 :to="{
									name: 'content',
									params: { slug: 'about-us' }
								}">
								<font-awesome-icon class="mr-2 ml-2 text-dark"
												   icon="info-circle" />درباره ما
							</router-link>
						</li>
						<li class="list-group-item  bg-light">
							<router-link class="text-dark"
										 :to="{
									name: 'content',
									params: { slug: 'contact-us' }
								}">
								<font-awesome-icon class="mr-2 ml-2 text-dark"
												   icon="phone" />تماس با ما
							</router-link>
						</li>
						<li class="list-group-item  bg-light">
							<router-link class="text-dark"
										 :to="{ name: 'auth' }">
								<font-awesome-icon class="mr-2 ml-2 text-dark"
												   icon="sign-in-alt" />ورود اعضا / ثبت نام
							</router-link>
						</li>
					</ul>
				</b-sidebar>
			</div>
		</div>

		<b-modal size="xl" hide-footer id="OrderingModal">
			<iframe v-bind:style="{ height: iframeHight }"
					class="iframe-mfe"
					src="https://mfe.nicard.ir/ordering">
			</iframe>
		</b-modal>

		<b-modal size="xl" hide-footer id="ShopRequestModal">
			<iframe v-bind:style="{ height: iframeHight }"
					class="iframe-mfe"
					src="https://mfe.nicard.ir/shop-request">
			</iframe>
		</b-modal>
	</nav>
</template>
<script>
import store from "@/store";
export default {
	props: {
		siteSetting: {
			type: Object
		}
	},

	data() {
		return {
			scrollPosition: 0,
			screenWidth: 0,
			cart: store.cart,
			customer: store.customer
		};
	},

	beforeMount() {
		this.screenWidth = window.outerWidth;
	},

	computed: {
		iframeHight() {
			if (this.screenWidth > 768) {
				return "450px";
			}

			return window.outerHeight + "px";
		}
	},

	mounted() {
		window.addEventListener("scroll", this.updateScroll);
	},

	methods: {
		updateScroll() {
			this.scrollPosition = window.scrollY;
		},

		onOver() {
			if (this.screenWidth > 768) {
				this.$refs.dropdown.visible = true;
			}
		},

		onLeave() {
			if (this.screenWidth > 768) {
				this.$refs.dropdown.visible = false;
			}
		},

		goToMarket()
		{
			if (store.user == null)
			{
				window.location.href = "https://nicard.ir";
			}
			else
			{
				window.location.href = "https://auth.nicard.ir/Manage";
			}
		}
	}
};
</script>
<style scoped>
.navbar {
	height: 60px;
	transition: all 0.5s;
}

.navbar a {
	font-size: 14px;
	color: #fff;
}

.navbar .navbar-brand a {
	text-decoration: none;
	color: #fff;
}

.navbar .navbar-brand .r {
	width: 30px;
	height: 30px;
	border-radius: 100%;
	display: inline-block;
	text-align: center;
	margin-right: 10px;
	padding-top: 4px;
	position: relative;
	top: -3px;
	transition: all 0.5s;
}

.navbar .navbar-brand .r img {
	max-width: 25px;
	padding-top: 3px;
}

.navbar a:hover svg {
	color: #f5c842 !important;
}

.navbar a svg,
.navbar a svg[data-icon="th"] {
	color: #fff;
}

.navbar.scroll {
	height: 50px;
	background: #292929;
}

.navbar.scroll a,
.navbar.scroll svg[data-icon="th"] {
	color: #fff;
}

.navbar.scroll svg[data-icon="th"] {
	color: #fff;
}

.navbar .navbar-nav {
	padding-right: 0;
}

button {
	padding: 0px !important;
}

.iframe-mfe {
	width: 100%;
	border: unset;
	background: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 100% 100%"><text fill="%23FF0000" x="50%" y="50%" font-family="\'Lucida Grande\', sans-serif" font-size="24" text-anchor="middle">لطفا کمی صبر کنید</text></svg>')
		0px 0px no-repeat;
}
</style>
